import fetchAPI from '../../../utils/fetchApi';

const BUDGET_URL = 'https://www.marktplaats.nl/x/overdrive';

export default async function getBudget() {
  try {
    return await fetchAPI({
      url: BUDGET_URL,
      method: 'GET',
    });
  } catch {
    return false;
  }
}
